import React from "react";
import { projectsData } from "./projectsDB";
import style from "./projects.module.css";

export default function Projects() {
  return (
    <div className={style.container} id="projects">
      <h1>Projects</h1>
      <div className={style.projectContainer}>
        {projectsData.map((project, i) => {
          return (
            <a href={project.linkApp} key={i}>
              <div href={project.linkApp} className={style.projectInfo}>
                <h3>{project.name}</h3>
                <img src={project.previewImg} alt="" />
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
